import AppShell from "@/components/layouts/AppShell";

/**
 * ProfileShell — layout persistente da área "Perfil".
 * Reaproveita o AppShell genérico (BottomNav fixa montada uma única vez).
 */
export default function ProfileShell() {
  return <AppShell />;
}
